import script from "./NewsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsSlider.vue?vue&type=script&setup=true&lang=js"

import "./NewsSlider.vue?vue&type=style&index=0&id=d1f01a02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1f01a02"]])

export default __exports__